export default __webpack_public_path__ + "static/media/justin-sun.bd55b667.svg";